<ng-template let-extraClass="extraClass" #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="pageTitle"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container
*ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <ng-container
    *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }" />
    @if (loaded) {
      @if (rule) {
        <tidy-card>
          <form [formGroup]="form">
            <tidy-row>
              <tidy-textarea
                label="Rule"
                formControlName="rule"
                [icon]="'assets/svg/information-circle.svg'"
                [form]="form.controls.rule"
                [submitted]="submitted"
                [errorMessage]="'Please enter the rule.'" />
            </tidy-row>
          </form>
        </tidy-card>
      }
      @if (!rule && cameFromOnboarding) {
        <tidy-row>
          <tidy-text [header]="'Popular Rules'" />
        </tidy-row>
        <tidy-card>
          <tidy-row>
            @for (rule of popularRules; track rule) {
              <ion-chip (click)="addPopularRule(rule)" [class.added]="rule.added">
                <tidy-text [body]="rule.name" />
              </ion-chip>
            }
          </tidy-row>
        </tidy-card>
      }
      @if (!rule) {
        <tidy-card>
          <form [formArray]="forms">
            @for (item of forms.controls; track item; let i = $index; let first = $first) {
              <tidy-row
                >
                <form [formGroup]="item">
                  <tidy-textarea
                    label="Rule"
                    formControlName="rule"
                    [icon]="'assets/svg/information-circle.svg'"
                    [form]="item"
                    [submitted]="submitted"
                    [errorMessage]="'Please enter the rule.'" />
                  @if (!first) {
                    <tidy-row [align]="'end'">
                      <tidy-text
                        [actionBody]="'Remove'"
                        (action)="removeRule(i, item.value.rule)"
                        class="link red" />
                    </tidy-row>
                  }
                </form>
              </tidy-row>
            }
          </form>
          <tidy-row [align]="'center'">
            <tidy-text
              [actionBody]="'+ Add Another Rule'"
              (action)="addRule()"
              class="link" />
          </tidy-row>
        </tidy-card>
      }
      <tidy-button
        [action]="boundSaveRule"
        class="primary"
        [text]="rule ? 'Save Change' : 'Add Rule(s)'" />
      @if (rule) {
        <tidy-row [align]="'center'">
          <tidy-text
            [actionBody]="'Delete Rule'"
            (action)="deleteRule()"
            class="link red" />
        </tidy-row>
      }
    }

    @if (errorMessage) {
      <tidy-error-message [text]="errorMessage" />
    }

  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
